/** @jsx jsx */
import { useRef, useState, useEffect } from 'react';
import { Button, Box, Container, jsx } from 'theme-ui';
import { AiOutlineUser } from 'react-icons/ai';
import { IoIosSearch } from 'react-icons/io';
import Logo from '../../ui-elements/logo/logo';
import Search from '../../search';
import MainMenu from './main-menu';
import useOnClickOutside from '../../../hooks/useOutsideClick';
import styles from './navbar.style';
// logo img
import logoImg from '../../../images/logo.svg';

const Navbar: React.FC<{}> = () => {
	const [visible, setVisible] = useState(false);
	const searchRef = useRef(null!);
	useOnClickOutside(searchRef, () => setVisible(false));

	return (
		<Box as="nav" sx={styles.navbar}>
			<Container
				className={visible ? 'activeSearch' : ''}
				sx={styles.container}
			>
				<Logo imgSrc={logoImg} />
				<MainMenu />
				<Box className="rightPart" sx={styles.rightPart}>
					{visible ? (
						<Box sx={styles.search} ref={searchRef}>
							<Search />
						</Box>
					) : (
						<Button
							sx={{ svg: { width: 23 } }}
							variant="text"
							onClick={() => setVisible(true)}
						>
							<IoIosSearch />
						</Button>
					)}
					<a href="https://picksystore.myshopify.com/account" target="_blank">
						<AiOutlineUser />
					</a>
				</Box>
			</Container>
		</Box>
	);
};

export default Navbar;
